module.exports = __webpack_public_path__ + "static/media/BBVA.c268c933.png";